import SessionStorageSynchronizer from '~/utils/sync-sessionstorage';

export const useEzwelAuthInfo = () => {
    const ezwelAuthInfoHandler = {
        getIfPossible: (): AuthInfo | null | undefined => {
            if (import.meta.client) {
                const authInfoJson  = SessionStorageSynchronizer.getItem('common.auth.info');
                if (authInfoJson) {
                    return JSON.parse(authInfoJson);
                } else {
                    return null;
                }
            }

        },
        on: (callback: (authInfo?: AuthInfo | null) => void) => {
            if (import.meta.client) {
                const rv = ezwelAuthInfoHandler.getIfPossible();
                callback(rv ? rv : null);
            }
        },
        onExist: (callback: (authInfo: AuthInfo) => void) => {
            ezwelAuthInfoHandler.on(authInfo => {
                if (authInfo) {
                    callback(authInfo);
                }
            });
        },
        set: (authInfo?: AuthInfo) => {
            if (import.meta.client) {
                if (authInfo) {
                    SessionStorageSynchronizer.setItem('common.auth.info', JSON.stringify(authInfo));
                    return true;
                }
            }
            return false;
        },
        clear: () => {
            SessionStorageSynchronizer.removeItem('common.auth.info');
        },
    }
    return ezwelAuthInfoHandler;
};











